<div class="company-equipment" *ngIf="equipmentMacaddress === ''">
  <div class="company-equipment__heading">
    <button class="vox-btn vox-btn-secondary company-equipment__add-equipment"
      [disabled]="company.readOnly"
      (click)="openAddEquipmentPopup()" translate>equipment.add-button</button>
    <div class="company-equipment__set-blf" *ngIf="loading">
      <ngx-skeleton-loader [theme]="{'width': '200px' , 'height': '41px', 'margin-bottom': 0, 'margin-right': '15px' }" ></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{'width': '60px' , 'height': '41px','margin-bottom': 0 }" ></ngx-skeleton-loader>
    </div>
    <div class="company-equipment__set-blf" *ngIf="!loading">
      <label>
        {{'company.equipment.set-pbx-blf' | translate}}
        <i class="icon-small-info" [ngbTooltip]="tooltip"></i>
        <ng-template #tooltip>
          <span [innerHTML]="'company.equipment.pbx-blf-tooltip' | translate"></span>
        </ng-template>
      </label>
      <input class="vox-checkbox"
        type="checkbox"
        [(ngModel)]="companyBLF"
        [indeterminate]="companyBLF === undefined"
        [disabled]="loadingBLF"
        [ngModelOptions]="{standalone: true}"/>
      <button class="vox-btn vox-btn-secondary"
        [ladda]="loadingBLF"
        [disabled]="company.readOnly || companyBLF === undefined || loadingBLF"
        (click)="setBlf()">
        {{'common.save' | translate}}
      </button>
    </div>
  </div>
  <div class="company-equipment__filters">
    <gdp-equipment-filters [lockedFilters]="lockedFilters" [limitedAvailableFilters]="limitedAvailableFilters" [filters]="filters" (filtersChanged)="filterChanged($event)"></gdp-equipment-filters>
  </div>
  <div class="company-equipment__table">
    <gdp-equipment-table [equipmentList]="equipmentList" [loading]="loading" [loadingLines]="loadingLines"></gdp-equipment-table>
  </div>
  <gdp-table-pagination (onSelectPageSize)="selectPageSize($event)" (onChangeCurrentPage)="changeCurrentPage($event)" [totalPages]="pagination.totalPages" [pagination]="pagination" [selectedPageSize]="pageSize"></gdp-table-pagination>
</div>
<div class="company-equipment__details" *ngIf="equipmentMacaddress !== ''">
  <gdp-single-equipment [company]="company" class="company-single-equipment"></gdp-single-equipment>
</div>
